import { toaster } from 'uikit/Toaster'
import { api } from 'api'
import { useMutation } from '@tanstack/react-query'

export const useCreateBannerItem = () => {
  
  return useMutation({
    mutationFn: (data) => api.banner.createItem(data),
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Баннер успешно создан',
        type: 'success',
      })
    },
    onError: (err) => {
      toaster.create({
        title: 'Не удалось создать баннер',
        description: err.message,
        type: 'error',
      })
    },
  })
}
